// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/payroll-cycles",
  Short: "/pyr/payroll-cycles/short",
  Detail: "/pyr/payroll-cycles",
  Create: "/pyr/payroll-cycles",
  Update: "/pyr/payroll-cycles",
  Delete: "/pyr/payroll-cycles",
  active: "/pyr/payroll-cycles/{id}/active",
  inactive: "/pyr/payroll-cycles/{id}/inactive",
};
